import { Component } from '@angular/core';

/* Copyright IBM Corp. 2017 */
@Component({
  selector: 'app-default',
  templateUrl: './default.component.html',
  styleUrls: ['./default.component.css'],
  preserveWhitespaces: false
})
export class DefaultComponent {
}
